// socket连接
export default "wss://zhaixiaoqu.com/wechat/api/orderStaffSocket/"; //域名+线上
// export default "ws://192.168.2.43:8089/orderStaffSocket/"; //本地王天龙
// export default "ws://192.168.2.27:8089/orderStaffSocket/"; //本地徐涛



// WEBPACK FOOTER //
// ./src/util/scoketUrl.js